import React from 'react';
import { NotificationProvider } from './NotificationContext';
import { FavoritesProvider } from './FavoritesContext';
import { CartProvider } from './CartContext';
import { SocialProofProvider } from './SocialProofContext';
import { AudioProvider } from './AudioContext';

export const UIProviders: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <NotificationProvider>
    <FavoritesProvider>
      <CartProvider>
        <SocialProofProvider>
          <AudioProvider>
            {children}
          </AudioProvider>
        </SocialProofProvider>
      </CartProvider>
    </FavoritesProvider>
  </NotificationProvider>
);
